import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'

const FeaturesCard = (props) => {
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <div 
            className={ props.customClass + " MS---Features_card"} 
            data-aos={props.cardAnimate}
        >
            <img src={props.icon} className="img-fluid w-100" />
            <h3 className="mb-2">{props.heading}</h3>
            {/* <img src={props.icon} className="img-fluid my-1" /> */}
            <p className="text-center px-2 mb-0" style={{fontSize:11}}>{props.text}</p>
        </div>
    );
}

export default FeaturesCard;